/** Same rules as backend PATCH /api/people/:id contact validation. */
export function looksLikeEmail(s: string): boolean {
  const t = (s || '').trim();
  return t.length >= 5 && t.includes('@') && t.indexOf('@') > 0 && t.indexOf('@') < t.length - 1;
}
